import { ApiResponse } from "../common/type";
import axiosClient from "./axiosClient";

const visitApi = {
    visit: async (): Promise<ApiResponse<any>> => {
        return axiosClient.post('/tracking/visit', {  // GET -> POST
            referrer: document.referrer || null,
            page: window.location.href,
        });
    },
    countVisit: async (): Promise<ApiResponse<any>> => {
        return axiosClient.get('/tracking/stats');
    },
};

export default visitApi;